module.exports = __webpack_public_path__ + "img/icon-oralstrips.4a83240f.svg";